<script>
    import { onMount } from 'svelte';

    export let text_lines = 6;

    let lines = null;

    onMount(async () => {
        lines = Array(text_lines);
	});
</script>
<div class="waiting-placeholder-text">
    {#if lines != null}
        {#each lines as foo}
            <span></span>
        {/each}
    {/if}
</div>

<style>
.waiting-placeholder-text{
	animation-duration: 4s;
	animation-name: fadein;
	animation-iteration-count: infinite;
}
.waiting-placeholder-text span{
	background: var(--medium-color);
	display: block;
	height: 15px;
	margin-bottom: 10px;
	width: 100%;
    border-radius: 4px;
}

.waiting-placeholder-text span:last-of-type{
	width: 75%;
}
@keyframes fadein {
	0% {
		opacity: 0;
	}

	25% {
		opacity: 1;
	}

	50% {
		opacity: 0;
	}

	75% {
		opacity: 1;
	}
  
	100% {
		opacity: 0;
	}
}
</style>